import script from "./SamlCallback.vue?vue&type=script&setup=true&lang=ts"
export * from "./SamlCallback.vue?vue&type=script&setup=true&lang=ts"

import "./SamlCallback.vue?vue&type=style&index=0&id=0c94d9dd&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c94d9dd"]])

export default __exports__